import { render, staticRenderFns } from "./ReferralServices.vue?vue&type=template&id=bdafc3d0&scoped=true"
import script from "./ReferralServices.vue?vue&type=script&lang=js"
export * from "./ReferralServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdafc3d0",
  null
  
)

export default component.exports